export default __webpack_public_path__ + "static/about-rocket-36b342d165d30d181ab66fb6eca373ea.svg";